import { render } from "./ProdutosNecessidadeManual.vue?vue&type=template&id=2652df44&scoped=true"
import script from "./ProdutosNecessidadeManual.vue?vue&type=script&lang=js"
export * from "./ProdutosNecessidadeManual.vue?vue&type=script&lang=js"

import "./ProdutosNecessidadeManual.vue?vue&type=style&index=0&id=2652df44&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2652df44"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBar from 'quasar/src/components/bar/QBar.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTable,QTd,QInput,QPagination,QDialog,QCard,QBar,QSpace,QCardSection,QLinearProgress,QCardActions});qInstall(script, 'directives', {ClosePopup});
